/* YUF theme — cart drawer + product/variant selection wired to Shopify's real AJAX Cart API. */
(function () {
  "use strict";

  var COLOR_HEX = {
    "Black": "#161616", "White": "#f2f0ea", "Apricot": "#e3a97e", "Army Green": "#4b5738",
    "Navy Blue": "#1f2c47", "Coffee": "#4a3524", "Gray": "#8c8c8c", "Light Apricot": "#eccba3",
    "Blue": "#3f6089", "Flower Gray": "#b7b3ad", "Gray Green": "#7c8a6e", "Ancora Red": "#8f2431"
  };

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return "$" + amount;
  }

  /* ---------- PRODUCT CARD / PRODUCT PAGE VARIANT PICKER ---------- */
  function initProductCard(card) {
    var dataEl = card.querySelector("[data-variant-data]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var state = { color: variants[0].option1, size: null };

    var mediaEl = card.querySelector("[data-card-media]");
    var swatchesEl = card.querySelector("[data-swatches]");
    var sizesEl = card.querySelector("[data-sizes]");
    var colorLabelEl = card.querySelector("[data-color-label]");
    var priceEl = card.querySelector("[data-price]");
    var addBtn = card.querySelector("[data-add-btn]");

    function variantsForColor(color) {
      return variants.filter(function (v) { return v.option1 === color; });
    }
    function findVariant(color, size) {
      return variants.filter(function (v) { return v.option1 === color && v.option2 === size; })[0];
    }
    function updateMedia() {
      var match = findVariant(state.color, state.size) || variantsForColor(state.color)[0];
      if (match && match.featured_image && match.featured_image.src) {
        mediaEl.style.backgroundImage = "url('" + match.featured_image.src + "')";
        mediaEl.style.backgroundColor = "";
      } else {
        mediaEl.style.backgroundImage = "";
        mediaEl.style.backgroundColor = COLOR_HEX[state.color] || "#565656";
      }
    }
    function updateAvailability() {
      if (!sizesEl) return;
      var btns = sizesEl.querySelectorAll(".size-btn");
      var available = variantsForColor(state.color).filter(function (v) { return v.available; }).map(function (v) { return v.option2; });
      btns.forEach(function (btn) {
        var ok = available.indexOf(btn.dataset.size) !== -1;
        btn.disabled = !ok;
      });
    }
    function updatePrice() {
      var match = findVariant(state.color, state.size) || variantsForColor(state.color)[0];
      if (match && priceEl) priceEl.textContent = formatMoney(match.price);
    }

    if (swatchesEl) {
      swatchesEl.querySelectorAll(".swatch").forEach(function (sw) {
        sw.style.background = COLOR_HEX[sw.dataset.color] || "#555";
        if (sw.dataset.color === state.color) sw.classList.add("active");
        sw.addEventListener("click", function () {
          state.color = sw.dataset.color;
          swatchesEl.querySelectorAll(".swatch").forEach(function (s) { s.classList.toggle("active", s === sw); });
          if (colorLabelEl) colorLabelEl.textContent = state.color;
          updateMedia();
          updateAvailability();
          updatePrice();
        });
      });
    }

    if (sizesEl) {
      sizesEl.querySelectorAll(".size-btn").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.disabled) return;
          state.size = btn.dataset.size;
          sizesEl.querySelectorAll(".size-btn").forEach(function (b) { b.classList.toggle("active", b === btn); });
          updatePrice();
        });
      });
    }

    // Paint in the initially-selected variant's image/price/availability
    // immediately on load, instead of waiting for a swatch click.
    updateMedia();
    updateAvailability();
    updatePrice();

    if (addBtn) {
      addBtn.addEventListener("click", function () {
        if (!state.size) {
          var original = addBtn.textContent;
          addBtn.textContent = "Pick a size";
          setTimeout(function () { addBtn.textContent = original; }, 1200);
          return;
        }
        var variant = findVariant(state.color, state.size);
        if (!variant || !variant.available) {
          addBtn.textContent = "Sold Out";
          setTimeout(function () { addBtn.textContent = "Add to Cart"; }, 1200);
          return;
        }
        addToCart(variant.id, 1, addBtn);
      });
    }

    updateMedia();
    updateAvailability();
    updatePrice();
  }

  document.querySelectorAll("[data-product-card]").forEach(initProductCard);

  /* ---------- SHOPIFY AJAX CART ---------- */
  function addToCart(variantId, quantity, triggerBtn) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (triggerBtn) {
          triggerBtn.textContent = "Added ✓";
          triggerBtn.classList.add("added");
          setTimeout(function () { triggerBtn.textContent = "Add to Cart"; triggerBtn.classList.remove("added"); }, 1000);
        }
        refreshCart();
        openCart();
      })
      .catch(function (err) { console.error("YUF add-to-cart failed:", err); });
  }

  function changeLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function renderCart(cart) {
    var body = document.getElementById("cartBody");
    var countEl = document.getElementById("cartCount");
    var subtotalEl = document.getElementById("subtotalAmt");
    if (!body) return;

    countEl.textContent = cart.item_count;
    subtotalEl.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty">Your cart is empty. Go find your fit.</div>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? "background-image:url('" + item.image + "')" : "background:#565656";
      return (
        '<div class="cart-line" data-key="' + item.key + '">' +
          '<div class="cart-swatch" style="' + img + '"></div>' +
          '<div class="cart-line-info">' +
            '<div class="cart-line-title">' + item.product_title + "</div>" +
            '<div class="cart-line-meta">' + item.variant_title + "</div>" +
            '<div class="cart-line-ctrl">' +
              '<button class="qty-btn" data-act="dec" data-key="' + item.key + '">−</button>' +
              "<span>" + item.quantity + "</span>" +
              '<button class="qty-btn" data-act="inc" data-key="' + item.key + '">+</button>' +
              '<span class="remove-line" data-act="remove" data-key="' + item.key + '">Remove</span>' +
            "</div>" +
          "</div>" +
          '<div class="cart-line-price">' + formatMoney(item.final_line_price) + "</div>" +
        "</div>"
      );
    }).join("");
  }

  function refreshCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
  }

  var cartBody = document.getElementById("cartBody");
  if (cartBody) {
    cartBody.addEventListener("click", function (e) {
      var el = e.target.closest("[data-act]");
      if (!el) return;
      var key = el.dataset.key;
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!line) return;
        if (el.dataset.act === "inc") changeLine(key, line.quantity + 1);
        if (el.dataset.act === "dec") changeLine(key, Math.max(0, line.quantity - 1));
        if (el.dataset.act === "remove") changeLine(key, 0);
      });
    });
  }

  var drawer = document.getElementById("cartDrawer");
  var overlay = document.getElementById("overlay");
  function openCart() { if (drawer) drawer.classList.add("open"); if (overlay) overlay.classList.add("open"); }
  function closeCart() { if (drawer) drawer.classList.remove("open"); if (overlay) overlay.classList.remove("open"); }

  var openBtn = document.getElementById("cartOpenBtn");
  var closeBtn = document.getElementById("cartCloseBtn");
  if (openBtn) openBtn.addEventListener("click", function () { refreshCart(); openCart(); });
  if (closeBtn) closeBtn.addEventListener("click", closeCart);
  if (overlay) overlay.addEventListener("click", closeCart);

  /* ---------- MOBILE HEADER MENU ---------- */
  var menuToggle = document.getElementById("HeaderMenuToggle");
  var headerMenu = document.getElementById("HeaderMenu");

  function closeHeaderMenu() {
    if (!menuToggle || !headerMenu) return;
    menuToggle.setAttribute("aria-expanded", "false");
    headerMenu.classList.remove("is-open");
  }

  if (menuToggle && headerMenu) {
    menuToggle.addEventListener("click", function () {
      var isOpen = menuToggle.getAttribute("aria-expanded") === "true";
      menuToggle.setAttribute("aria-expanded", String(!isOpen));
      headerMenu.classList.toggle("is-open", !isOpen);
    });

    headerMenu.addEventListener("click", function (event) {
      if (event.target.closest("a")) closeHeaderMenu();
    });

    document.addEventListener("click", function (event) {
      if (!event.target.closest(".nav")) closeHeaderMenu();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeHeaderMenu();
        menuToggle.focus();
      }
    });
  }

  refreshCart();
})();
